<template lang="pug">
	.app-core--loading-line
		.indicator(:style="styleInfo")
			.sub-indicator
</template>

<script>

import VueTypes from 'vue-types';

export default {
	model: {
		prop: 'pageIndex',
		event: 'change'
	},
	props: {
		time: VueTypes.number.def(2),
		width: VueTypes.any.def(null),
		height: VueTypes.any.def(null)
	},
	computed: {
		styleInfo() {
			var res = {};
			if (this.width) {
				res.width = this.width;
			}

			res.height = this.height || '3px';
			res['--time'] = `${this.time}s`;
			return res;
		}
	}
};

</script>

<style lang="scss">
	@import "main/themes/generated/variables.base.scss";

	.app-core--loading-line {
		user-select: none;

		.indicator {
			background: rgba(0,0,0,0.1);
			position: relative;
			overflow: hidden;
		}

		.sub-indicator {
			position: absolute;
			width: 50%;
			height: 100%;
			left: -90%;
			animation: loading-anim var(--time) ease-in-out infinite;
			background: $base-accent;
		}

		@keyframes loading-anim {
			0% { left: -50% }
			100% { left: 100%; }
		}
	}
</style>
